import React from 'react'
import PropTypes from 'prop-types'
import ImageFallback from 'Components/imagefallback/next_image'

const MaleDailyArticleCardThree = ({
  isMobile,
  image,
  title,
  url,
  category,
}) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <a
        className={`article-style-three article-style-three--${device}`}
        href={url}
      >
        <div
          className={`article-style-three__image article-style-three__image--${device}`}
        >
          <ImageFallback
            objectFit="cover"
            alt={title}
            src={image || process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_SQUARE}
            fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
            width={548}
            height={308}
            quality={100}
          />
        </div>
        <div className="article-style-three__text">
          <div className="article-style-three__category fd-body-sm-regular">
            {category?.replace(/_/gi, ' ')}
          </div>
          <div className="article-style-three__title fd-heading-4">{title}</div>
        </div>
      </a>
      <style jsx>
        {`
          .article-style-three {
            display: grid;
            grid-template-columns: 274px 1fr;
            gap: var(--space-20);
            text-decoration: none;
          }

          .article-style-three--mobile {
            grid-template-columns: 156px 1fr;
          }

          .article-style-three__image {
            width: 274px;
            height: 154px;
            position: relative;
            aspect-ratio: 16/9;
          }

          .article-style-three__image--mobile {
            width: 156px;
            height: auto;
          }

          .article-style-three__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-three__image--mobile {
            width: 156px;
            height: auto;
          }

          .article-style-three__category {
            color: var(--text-sub);
            text-transform: capitalize;
          }

          .article-style-three__title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .article-style-three__title:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardThree.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  category: PropTypes.string,
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardThree
